// extracted by mini-css-extract-plugin
export default {"root":"HomePage_root__gX3oW","stack__full":"HomePage_stack__full__XccR4","stack__fitcontent":"HomePage_stack__fitcontent__UyyPT","privacy_screen":"HomePage_privacy_screen__uQaS7"};